import { Types } from "../actions/OperatorRequestActions";

const initialState = {
    creators: {},
    unplannedMaintenanceStatus: {},
    infoLoading: true,
    cancelOrder: {},
    confirmOrder: {},
};

export const operatorRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_CREATORS:
            return {
                ...state,
                creators: action.payload || state.creators,
                infoLoading: false,
            };
        case Types.SET_STATUS:
            return {
                ...state,
                unplannedMaintenanceStatus: action.payload || state.unplannedMaintenanceStatus,
            };
        case Types.SET_CANCEL_ORDER:
            return {
                ...state,
                cancelOrder: action.payload || state.cancelOrder,
            };
        case Types.SET_CONFIRM_ORDER:
            return {
                ...state,
                confirmOrder: action.payload || state.confirmOrder,
            };
        case Types.RESET_CANCEL_ORDER:
            return {
                ...state,
                cancelOrder: {},
            };
        case Types.EMPTY_STATUS:
            return {
                ...state,
                unplannedMaintenanceStatus: {},
            };

        default:
            return state;
    }
};
